const dataTypes = {
  id: "dataTypes",
  label: "Data Types",
  endpoint: "data_types",
  columnConfig: [
    {
      field: "name",
      headerName: "Data Type",
      width: 250,
      description: "Data Type",
      editable: true,
    },
    {
      field: "description",
      headerName: "Description",
      width: 250,
      description: "Description",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default dataTypes;
